import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/constants/appRoutes'
import { EUserStatus } from '@/constants/userStatus'
import { useUserInfoQuery } from '@/store/api/Users/Users.query'
import cookieService from '@/utils/cookies'

import {
  PUBLIC_ROUTES,
  STATUS_ALLOWED_ROUTES,
  STATUS_DEFAULT_ROUTE,
} from './statusGuardConfig'

export const useStatusGuard = () => {
  const { data: userData, isSuccess } = useUserInfoQuery()
  const userStatus = userData?.status
  const location = useLocation()
  const navigate = useNavigate()
  const currentPath = location.pathname

  useEffect(() => {
    if (!userStatus) return

    if (PUBLIC_ROUTES.includes(currentPath as AppRoutes)) {
      return
    }

    if (
      userStatus === EUserStatus.BLOCKED ||
      userStatus === EUserStatus.DELETED ||
      userStatus === EUserStatus.PENDING
    ) {
      // Remove CloudFront cookies when user is blocked, deleted or pending
      cookieService.removeCloudFrontCookies()

      navigate(AppRoutes.login, { replace: true })
      return
    }

    // Get allowed routes for the user status
    const allowedRoutes = STATUS_ALLOWED_ROUTES[userStatus] || []

    // Check if the current path is allowed
    const isRouteAllowed = allowedRoutes.some((route) =>
      currentPath.startsWith(route),
    )

    if (!isRouteAllowed) {
      const defaultRoute = STATUS_DEFAULT_ROUTE[userStatus]
      navigate(defaultRoute, { replace: true })
    }
  }, [isSuccess])

  return {
    userStatus,
    currentPath,
  }
}
